import React from 'react'

const SvgIconShare = (props) => (
  <svg viewBox="0 0 24 29" {...props}>
    <path
      d="M18.424.121c-2.763 0-5.025 2.262-5.025 5.025 0 .432.064.845.168 1.246l-5.454 4.176a4.997 4.997 0 0 0-3.088-1.067C2.262 9.5 0 11.762 0 14.525s2.262 5.025 5.025 5.025a4.996 4.996 0 0 0 3.098-1.078l5.444 4.176c-.106.404-.168.821-.168 1.257 0 2.763 2.262 5.024 5.025 5.024 2.763 0 5.024-2.261 5.024-5.024 0-2.764-2.261-5.025-5.024-5.025-1.602 0-3.035.76-3.957 1.937l-5.035-3.884a4.968 4.968 0 0 0 .617-2.408c0-.877-.229-1.698-.628-2.418l5.046-3.883a5.016 5.016 0 0 0 3.957 1.947c2.763 0 5.024-2.262 5.024-5.025 0-2.763-2.261-5.025-5.024-5.025zm0 2.01a3 3 0 0 1 3.014 3.015 3 3 0 0 1-3.014 3.015 3 3 0 0 1-3.015-3.015 3 3 0 0 1 3.015-3.015zm-13.4 9.38a3 3 0 0 1 3.015 3.014 3 3 0 0 1-3.014 3.015 3 3 0 0 1-3.015-3.015 3 3 0 0 1 3.015-3.015zm13.4 9.379a3 3 0 0 1 3.014 3.015 3 3 0 0 1-3.014 3.014 3 3 0 0 1-3.015-3.014 3 3 0 0 1 3.015-3.015z"
      fillRule="nonzero"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconShare
